import NiceModal from "@ebay/nice-modal-react";
import { adminRequester } from "App";
import P from "components/P";
import AdminCustomButton from "components/buttons/AdminCustomButton";
import InputText from "components/inputs/InputText";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import ModalBase from "modals/base/ModalBase";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./CategoryRegisterModal.module.css";
const CategoryRegisterModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const { editable = true } = props;
  const [withHeader, withFooter] = [true, false];
  const [isMounted, setMounted] = useState(false);
  const [reload, setReload] = useState(false);
  const [categories, setCategories] = useState([]);
  const [width, height] = ["min(95%, 1200px)", "80vh"];
  const withCloseButton = true;
  const modal = useRef();
  const clickOutsideToClose = true;
  const title = editable ? "카테고리 등록" : "카테고리 선택";
  const buttonText = t("close");
  const { isMobile } = useContext(BrowserDetectContext);
  const [selected, setSelected] = useState([]);
  const input = useRef();

  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      adminRequester.getCategories(
        {
          expand: "parent_category,category_children",
          include_descendants_tree: true,
          parent_category_id: "null",
        },
        (result) => setCategories(result.product_categories)
      );
    }
  }, [isMounted]);
  const transferToFlat = (categories) => {
    return categories
      .map((category) => {
        return [
          category,
          ...transferToFlat(category?.category_children).flat(),
        ];
      })
      .flat();
  };
  useEffect(() => {
    if (reload) {
      adminRequester.getCategories(
        {
          expand: "parent_category,category_children",
          include_descendants_tree: true,
          parent_category_id: "null",
        },
        (result) => {
          const categories = result.product_categories;
          setCategories(categories);
          const flatCategories = transferToFlat(categories);

          setSelected([
            ...selected.map(
              (select) =>
                flatCategories.find((category) => category.id === select.id) ||
                select
            ),
          ]);
          // setSelected([...selected]);
        }
      );
      setReload(false);
    }
  }, [reload]);
  const getHandle = (category) => {
    return category.parent_category
      ? `${getHandle(category.parent_category)}_${category.handle}`
      : category.handle;
  };
  const addCategory = () => {
    const name = input.current.getValue();
    if (name) {
      if (!name) return;
      const select =
        selected?.length > 0 ? selected[selected?.length - 1] : null;
      const handle = (selected?.length > 0
        ? `${getHandle(select)}_${name}`
        : name
      ).replace(" ", "_");

      adminRequester.postCategories(
        {
          name: name,
          handle: handle,
          parent_category_id: select?.id,
          is_active: true,
          is_internal: false,
        },
        () => {
          setReload(true);
          input.current.empty();
        }
      );
    }
  };

  const onSaveClick = () => {
    if (selected?.length > 0) {
      const result = selected.reduce((pre, next) => {
        if (pre != null) {
          next.parent_category = pre;
        }
        return next;
      }, null);
      props.onChange({ props: props, value: result });
      modal.current.close();
    }
  };
  const onDeleteClick = () => {
    if (selected?.length > 0) {
      NiceModal.show("confirm", {
        onConfirm: () =>
          adminRequester.deleteCategory(
            selected[selected.length - 1].id,
            () => {
              setReload(true);
            }
          ),
        message: "카테고리를 삭제하시겠습니까?",
        cancelText: "취소",
        confirmText: "삭제",
      });
    }
  };
  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
    >
      <div className={style.wrap}>
        <div className={style.detailContainer}>
          <VerticalFlex flexStart={true} gap={30}>
            <FlexChild>
              <VerticalFlex>
                <HorizontalFlex>
                  <label style={{ fontWeight: "bold", width: "100%" }}>
                    대분류
                  </label>{" "}
                  <label style={{ fontWeight: "bold", width: "100%" }}>
                    중분류
                  </label>
                  <label style={{ fontWeight: "bold", width: "100%" }}>
                    소분류
                  </label>
                </HorizontalFlex>
                <HorizontalFlex>
                  <FlexChild>
                    <VerticalFlex
                      width="100%"
                      paddingLeft={10}
                      gap={5}
                      paddingTop={5}
                    >
                      {categories?.map((category, index) => (
                        <div
                          key={index}
                          onClick={() => {
                            selected[0] = category;
                            selected?.splice(1, 2);
                            setSelected([...selected]);
                          }}
                          style={{
                            textDecoration:
                              selected[0]?.id === category?.id
                                ? "underline"
                                : "",
                            cursor: "pointer",
                          }}
                        >
                          {category.name}
                        </div>
                      ))}
                    </VerticalFlex>
                  </FlexChild>
                  <FlexChild>
                    <VerticalFlex
                      width="100%"
                      paddingLeft={10}
                      gap={5}
                      paddingTop={5}
                    >
                      {selected?.[0]?.category_children?.length > 0 ? (
                        selected?.[0]?.category_children
                          ?.sort((a, b) => a.name.localeCompare(b.name))
                          ?.map((category, index) => (
                            <div
                              key={index}
                              onClick={() => {
                                selected[1] = category;
                                selected?.splice(2, 2);
                                setSelected([...selected]);
                              }}
                              style={{
                                textDecoration:
                                  selected[1]?.id === category?.id
                                    ? "underline"
                                    : "",
                                cursor: "pointer",
                              }}
                            >
                              {category.name}
                            </div>
                          ))
                      ) : (
                        <P>상위 카테고리를 골라주세요.</P>
                      )}
                    </VerticalFlex>
                  </FlexChild>
                  <FlexChild>
                    <VerticalFlex
                      width="100%"
                      paddingLeft={10}
                      gap={5}
                      paddingTop={5}
                    >
                      {selected?.[1]?.category_children?.length > 0 ? (
                        selected?.[1]?.category_children
                          ?.sort((a, b) => a.name.localeCompare(b.name))
                          ?.map((category, index) => (
                            <div
                              key={index}
                              onClick={() => {
                                selected[2] = category;
                                setSelected([...selected]);
                              }}
                              style={{
                                textDecoration:
                                  selected[2]?.id === category?.id
                                    ? "underline"
                                    : "",
                                cursor: "pointer",
                              }}
                            >
                              {category.name}
                            </div>
                          ))
                      ) : (
                        <P>상위 카테고리를 골라주세요.</P>
                      )}
                    </VerticalFlex>
                  </FlexChild>
                </HorizontalFlex>
              </VerticalFlex>
            </FlexChild>
            <HorizontalFlex>
              <FlexChild width="max-content">
                <VerticalFlex flexStart>
                  <FlexChild>
                    <label>- 선택된 카테고리 : </label>
                  </FlexChild>
                  {selected?.length > 0 && (
                    <AdminCustomButton
                      text="선택취소"
                      onClick={() => setSelected([])}
                    />
                  )}
                </VerticalFlex>
              </FlexChild>
              <VerticalFlex paddingLeft={10}>
                <label>
                  {selected.length > 0
                    ? `${selected[selected.length - 1]?.name}`
                    : "선택된 카테고리 없음"}
                </label>
                {editable &&
                  selected.length > 0 &&
                  selected[selected.length - 1]?.category_children?.length ===
                    0 && (
                    <AdminCustomButton onClick={onDeleteClick} text="삭제" />
                  )}
              </VerticalFlex>
            </HorizontalFlex>
            {editable && (
              <HorizontalFlex justifyContent="end" gap={10}>
                <FlexChild width={216}>
                  <InputText
                    ref={input}
                    type="text"
                    validable={false}
                    disabled={selected?.length === 3}
                  />
                </FlexChild>
                <FlexChild width="max-content">
                  <AdminCustomButton
                    style={{ height: 36, width: 46 }}
                    text="추가"
                    onClick={addCategory}
                    disabled={selected?.length === 3}
                  />
                </FlexChild>
              </HorizontalFlex>
            )}
            <HorizontalFlex justifyContent="center" gap={10}>
              <AdminCustomButton onClick={onSaveClick} text="등록" />
              <AdminCustomButton
                onClick={() => modal.current.close()}
                text="닫기"
              />
            </HorizontalFlex>
          </VerticalFlex>
        </div>
      </div>
    </ModalBase>
  );
});

export default CategoryRegisterModal;
